import React from "react";
import { Row, Col } from "react-bootstrap";

import { TextWithLoader } from "components";
import { LineDivider } from "components/layout";
import { CommissionsSplitsInformationProps } from "types";

import styles from "../commissionSplits.module.scss";

const CommissionsSplitsInformation = ({
	isLoading,
	initialValues,
}: CommissionsSplitsInformationProps) => {
	const {
		userFriendlyId,
		status,
		profileName,
		scenarioType,
		totalRevenueShare,
	} = initialValues ?? {};

	return (
		<div data-autotest="viewCommissionSplitInformationSection">
			<div>
				<h1 className={`${styles.header} ${"mb-3"}`}>
					Commission Splits Information
				</h1>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Profile ID:"
							value={userFriendlyId}
							loading={isLoading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Status:"
							value={status?.displayName}
							loading={isLoading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Profile Name:"
							value={profileName}
							loading={isLoading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Scenario:"
							value={scenarioType?.displayName}
							loading={isLoading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Total Revenue Share:"
							value={
								totalRevenueShare ? `${totalRevenueShare}%` : ""
							}
							loading={isLoading}
						/>
					</Col>
				</Row>

				<LineDivider />
			</div>
		</div>
	);
};

export default CommissionsSplitsInformation;
